<template>
    <div id="mapContainer" v-if="!loading">
        <gmap-map ref="gmap"
                  :center="marker"
                  :zoom="8"
                  style="width:100%;  height: 100%;"
                  :options="mapOptions">
            <gmap-marker :icon="markerIcon"
                         :position="marker"></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
    import Vue from 'vue'

    import * as VueGoogleMaps from 'vue2-google-maps'

    Vue.use(VueGoogleMaps, {
        load: {
            key: googleMapsApiKey
        }
    })

    export default {
        computed: {
            mapOptions: function () {
                return this.$store.state.mapOptions
            },

            marker: function () {
                return this.location && google && new google.maps.LatLng(this.location.latitude, this.location.longitude)
            },

            markerIcon: function () {
                return this.$store.state.mapOptions.markerIcon
            },
        },

        created: function () {
            var vm = this

            vm.$gmapApiPromiseLazy().then(() => vm.Init())
        },

        data() {
            return {
                loading: true
            }
        },

        methods: {
            Init: function () {
                this.loading = false
            }
        },

        props: {
            location: Object
        }
    }
</script>